/**
 * Arcanist reveal-on-scroll engine — ported from assets/js/reveal.js (PHP).
 *
 * SPLITTEXT SUBSTITUTION: data-reveal="words" and data-reveal="lines" use
 * ArcanistTextSplit (vanilla). Lines always measure rendered wraps via
 * offsetTop after word-span layout (<br> forces segment breaks). To restore
 * SplitText after licensing, replace splitWords/splitLines calls below and
 * load SplitText.min.js in arcanist-vendor-scripts.liquid.
 */
(function () {
  "use strict";

  var START = "top 90%";
  var STAGGER = 0.15;

  var REVEAL_TYPES = {
    "fade-in": { autoAlpha: 0, duration: 1, ease: "power2.out" },
    "fade-up": { autoAlpha: 0, y: 60, duration: 1, ease: "power2.out" },
    "fade-down": { autoAlpha: 0, y: -60, duration: 1, ease: "power2.out" },
    sticker: { autoAlpha: 0, scale: 1.4, rotation: "-=3", duration: 0.3, ease: "power2.out" },
    "slide-up": { yPercent: -100, duration: 1, ease: "power2.out" },
  };

  var WORD_DURATION = 0.6;
  var WORD_STAGGER = 0.03;
  var LINE_DURATION = 0.6;
  var LINE_STAGGER = 0.08;

  function sortByOrder(els) {
    return els.slice().sort(function (a, b) {
      var oa = parseFloat(a.dataset.revealOrder);
      var ob = parseFloat(b.dataset.revealOrder);
      return (isNaN(oa) ? 0 : oa) - (isNaN(ob) ? 0 : ob);
    });
  }

  function queryAll(root, selector) {
    if (root === document) return Array.prototype.slice.call(document.querySelectorAll(selector));
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function contains(root, node) {
    if (root === document) return document.documentElement.contains(node);
    return root.contains(node);
  }

  function animate(el, delay, triggerEl) {
    var cfg = REVEAL_TYPES[el.dataset.reveal];
    if (!cfg || typeof gsap === "undefined") return;
    gsap.from(
      el,
      Object.assign({}, cfg, {
        delay: delay,
        scrollTrigger: {
          trigger: triggerEl || el,
          start: el.dataset.revealStart || START,
          toggleActions: "play none none reverse",
        },
      })
    );
  }

  function initWordsReveal(root) {
    if (!window.ArcanistTextSplit) return;

    queryAll(root, '[data-reveal="words"]').forEach(function (el) {
      var words = ArcanistTextSplit.splitWords(el);
      if (!words.length) return;

      gsap.set(words, { autoAlpha: 0, y: 20 });
      gsap.set(el, { autoAlpha: 1 });

      var scrub = el.dataset.revealScrub != null ? parseFloat(el.dataset.revealScrub) || true : false;
      var st = {
        trigger: el,
        start: el.dataset.revealStart || START,
        invalidateOnRefresh: true,
      };

      if (scrub) {
        st.end = el.dataset.revealEnd || "top 30%";
        st.scrub = scrub;
      } else {
        st.toggleActions = "play none none reverse";
      }

      gsap.to(words, {
        autoAlpha: 1,
        y: 0,
        duration: WORD_DURATION,
        stagger: WORD_STAGGER,
        ease: scrub ? "none" : "power2.out",
        delay: scrub ? 0 : parseFloat(el.dataset.revealDelay) || 0,
        scrollTrigger: st,
      });
    });
  }

  function initLinesReveal(root) {
    if (!window.ArcanistTextSplit) return;

    queryAll(root, '[data-reveal="lines"]').forEach(function (el) {
      var lines = ArcanistTextSplit.splitLines(el);
      if (!lines.length) return;

      gsap.set(lines, { autoAlpha: 0, y: 8 });
      gsap.set(el, { autoAlpha: 1 });

      gsap.to(lines, {
        autoAlpha: 1,
        y: 0,
        duration: LINE_DURATION,
        stagger: LINE_STAGGER,
        ease: "power2.out",
        delay: parseFloat(el.dataset.revealDelay) || 0,
        scrollTrigger: {
          trigger: el,
          start: el.dataset.revealStart || START,
          toggleActions: "play none none reverse",
        },
      });
    });
  }

  function initParallax(root) {
    queryAll(root, "[data-parallax]").forEach(function (el) {
      var amount = parseFloat(el.dataset.parallax) || 12;
      var trigger = el.dataset.parallaxTrigger ? el.closest(el.dataset.parallaxTrigger) : el.parentElement;
      gsap.fromTo(
        el,
        { yPercent: -amount },
        {
          yPercent: amount,
          ease: "none",
          scrollTrigger: {
            trigger: trigger || el,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
          },
        }
      );
    });
  }

  function initReveal(root) {
    root = root || document;
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;

    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion) return;

    var groups = {};
    queryAll(root, "[data-reveal-group]").forEach(function (el) {
      var name = el.dataset.revealGroup;
      (groups[name] = groups[name] || []).push(el);
    });

    var grouped = [];
    Object.keys(groups).forEach(function (name) {
      var els = sortByOrder(groups[name]);
      grouped = grouped.concat(els);

      var stagger = STAGGER;
      var triggerOverride = null;
      els.forEach(function (el) {
        if (el.dataset.revealStagger) stagger = parseFloat(el.dataset.revealStagger);
        if (el.dataset.revealTrigger) triggerOverride = document.querySelector(el.dataset.revealTrigger);
      });
      var triggerEl = triggerOverride || els[0];

      els.forEach(function (el, i) {
        var delay = i * stagger + (parseFloat(el.dataset.revealDelay) || 0);
        animate(el, delay, triggerEl);
      });
    });

    queryAll(root, "[data-reveal]").forEach(function (el) {
      if (grouped.indexOf(el) !== -1) return;
      if (el.dataset.reveal === "words" || el.dataset.reveal === "lines") return;
      animate(el, parseFloat(el.dataset.revealDelay) || 0, null);
    });

    initWordsReveal(root);
    initLinesReveal(root);
    initParallax(root);
  }

  function destroyReveal(root) {
    if (typeof ScrollTrigger === "undefined") return;
    root = root || document;

    ScrollTrigger.getAll().forEach(function (st) {
      var trigger = st.trigger;
      if (!trigger) return;
      if (root === document || contains(root, trigger)) {
        st.kill();
      }
    });

    if (window.ArcanistTextSplit) {
      queryAll(root, '[data-reveal="words"], [data-reveal="lines"]').forEach(function (el) {
        ArcanistTextSplit.revert(el);
      });
    }
  }

  window.ArcanistReveal = { init: initReveal, destroy: destroyReveal };

  document.addEventListener("DOMContentLoaded", function () {
    initReveal(document);
    window.addEventListener("load", function () {
      ScrollTrigger.refresh();
    });
  });

  document.addEventListener("shopify:section:unload", function (event) {
    destroyReveal(event.target);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initReveal(event.target);
    ScrollTrigger.refresh();
  });
})();
